


















import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class MoneyBackGuarantee extends Vue {
    @Prop({
        default: false
    })
    lightVersion!: boolean;

    private get imgClass(): string {
        if (this.lightVersion) {
            return '';
        } else {
            return 'lg:float-left lg:mx-0 lg:mr-4 mb-4';
        }
    }

    private get imgMaxHeight(): string {
        if (this.lightVersion) {
            return '140px';
        } else {
            return '180px';
        }
    }
}
